import { usePostHog } from 'posthog-js/react';

import type { EventProperties, Events } from '@/lib/posthog/events';
import { isLocalEnv } from '@/utils/env';

/**
 * Use this hook to track events in the application. Events are sent to PostHog. Disabled in local environment.
 */
export const useTrackEvent = () => {
  const posthog = usePostHog();

  const trackEvent = <E extends Events>(
    ...arg: E extends keyof EventProperties ? [E, EventProperties[E]] : [E]
  ) => {
    const [event, properties] = arg;

    if (isLocalEnv) {
      // disable eslint `no-console` rule for logging in local environment
      // eslint-disable-next-line no-console
      console.log('DEBUG: trackEvent', event, properties);
    } else {
      posthog.capture(event, properties);
    }
  };

  return trackEvent;
};
